<template>
  <div class="body-sm" :class="alignmentClass">
    <p class="text-xs">
      This site is protected by reCAPTCHA <br />and the Google
      <a class="wc-focus font-semibold underline underline-offset-1 hover:text-primary-500 focus-visible:outline-offset-1" href="https://policies.google.com/privacy">Privacy Policy</a> and
      <a class="wc-focus font-semibold underline underline-offset-1 hover:text-primary-500 focus-visible:outline-offset-1" href="https://policies.google.com/terms">Terms of Service</a> apply.
    </p>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

defineOptions({
  name: 'BaseRecaptchaNotice',
})

const props = withDefaults(
  defineProps<{
    textAlignment?: 'left' | 'center' | 'right'
  }>(),
  {
    textAlignment: 'center',
  }
)

const alignmentClass = computed(() => {
  return {
    left: 'text-left',
    right: 'text-right',
    center: 'text-center',
  }[props.textAlignment]
})
</script>